module.exports = __webpack_public_path__ + "static/media/Rectangle 34.00bc3e67.png";